/* eslint-disable import/no-extraneous-dependencies */
/* eslint no-underscore-dangle: ["error", { "allow": [ "_id"] }] */

import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
import Tab from '@mui/material/Tab';
import { TabContext } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Roles from './roles';
import PermissionsComponent from './permissions';

export default function RoleAndPermission() {
  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper">
      <div className="pageTitleWrap">
        {/* <Stack direction="row" spacing={1} alignItems="center"> */}
        <Typography className="" component="h2" variant="h2">
          Roles & Permissions
        </Typography>
        {/* </Stack> */}
      </div>
      <Box className="tabWrapper" sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              textColor="secondary"
              indicatorColor="secondary"
              onChange={handleTabChange}
              aria-label="lab API tabs example"
            >
              <Tab label="Roles" value="1" />
              <Tab label="Permissions" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <Roles />
          </TabPanel>
          <TabPanel value="2">
            <PermissionsComponent />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
}
